import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import InitialState, { UpdateLoginAction } from '../redux/login';
import { userDetailsResponse } from '../../types';

const initialState: InitialState = {
  userDetails: {
    name: '',
    email: '',
    picture: '',
  },
  isLogin: false,
};

export const loginSlice = createSlice({
  name: UpdateLoginAction,
  initialState: initialState,
  reducers: {
    updateLoginUserDetails: (state, action: PayloadAction<userDetailsResponse>) => {
      state.userDetails = { ...action.payload };
      state.isLogin = true;
    },
    logoutUser: (state, action: PayloadAction<userDetailsResponse>) => {
      state.userDetails = { ...action.payload };
      state.isLogin = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateLoginUserDetails, logoutUser } = loginSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default loginSlice.reducer;
